module.exports = function getResource(label, vars = []) {
    let resources = {
        nameAll: 'Tous',
        nameOnlinePurchases: 'Achats en ligne',
        nameStorePurchases: 'Achat en magasin',
        nameRewardsGift: 'Récompenses et cadeaux'
    };
    return resources[label];
};
